import React from "react";

const ContactUsLink = () => {
  return (
    <div>
      Any issues?{" "}
      <a
        href="https://pdview.com.au/contact"
        target={"_blank"}
        rel={"noopener noreferrer"}
      >
        Contact us
      </a>
    </div>
  );
};

export default ContactUsLink;



// WEBPACK FOOTER //
// ./src/components/contact_us_link/ContactUsLink.jsx